module.exports = __webpack_public_path__ + "img/manchester-united.18962445.png";